import React, { useCallback, useEffect, useState } from "react";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../../hooks/useFetchData";
import {
  deleteProgramActionHandler,
  getAllProgramsCountOrganizeWithoutConditionActionHandler,
  getClassAndCollectionByProgramIdActionHandler,
  getRecentlyAddedProgramsSeriesMgmtActionHandler,
  updateProgramActionHandler,
} from "../../../../store/actions/actionHandlers/organizeActionHandler";
import { seriesManagement } from "../../../../utils/mainTabs/organize/seriesManagement";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import { useCheckList } from "../../../../hooks/useCheckList";
import { useDispatch } from "react-redux";
import Modal from "../../../../components/Common/Modal/Modal";
import ShotClassPreviewData from "./ShotClassPreviewData/ShotClassPreviewData";
import { useNavigate, useOutletContext } from "react-router";
import SeriesDeleteModal from "../../../DistributePage/DistributeSeries/SeriesDelete/SeriesDeleteModal";

const SeriesMgmtTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pageSize = 8;
  const [seriesColumns, setSeriesColumns] = useState([]);
  const [programCount, setProgramCount] = useState();
  const [previewSelectedDataModalOpen, setPreviewSelectedDataModalOpen] =
    useState(false);
  const { tenantName, setFilterBySearch } = useOutletContext();
  const [shotclassDataByProgram, setShotclassDataByProgram] = useState(null);
  const [previewCreator, setPreviewCreator] = useState();
  const [previewCreatedOn, setPreviewCreatedOn] = useState();
  const [deleteModal, setdeleteModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [deleteData, setdeleteData] = useState(null);
  const [programData, setProgramData] = useState(null);
  const [totalVideoDuration, setTotalVideoDuration] = useState([]);
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    searchQuery,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setProgramData,
      setTempProgramData,
      setTotalRows
    ) =>
      getRecentlyAddedProgramsSeriesMgmtActionHandler(
        searchText,
        pageNumber,
        pageSize,
        setProgramData,
        setTempProgramData,
        setTotalRows,
        "WithoutVTLT",
        "Published",
        "Program",
        searchText ? searchQuery : "none",
        "none"
      ),
    pageSize
  );

  const { searchPlaceholder, columns } = seriesManagement;

  const handleDelete = useCallback((Program) => {
    setdeleteModal(true);
    setProgramData(Program);
    // dispatch(
    //   deleteProgramActionHandler(ProgramID, handleSearchQuery, setLoader)
    // ).then((response) => {
    //   dispatch(
    //     setErrorHandler(
    //       errorTypes.SUCCESS,
    //       "Series has been deleted Successfully"
    //     )
    //   );
    // });
  }, []);
  const handleEdit = () => {};
  const handlePreview = (classID, name, createdOn) => {
    setLoader(true);
    setPreviewSelectedDataModalOpen(true);
    setPreviewCreator(name);
    setPreviewCreatedOn(createdOn);
    dispatch(
      getClassAndCollectionByProgramIdActionHandler(classID, "en-GB")
    ).then((response) => {
      if (response?.status === 200 && response?.data) {
        setShotclassDataByProgram(response?.data);
        setLoader(false);
      }
    });
  };
  useEffect(() => {
    var hrs = 0;
    var mins = 0;
    var sec = 0;
    shotclassDataByProgram?.forEach((item) => {
      if (item?.ShotClass.ID != 0) {
        var t1 =
          item?.ShotClass?.VideoDuration?.split(":") ||
          (item?.ShotClass?.VideoDuration == null &&
            item?.Programs?.VideoDuration.split(":"));
        var second = Number(t1?.[2]) + sec;
        var minutes =
          Math?.floor(parseInt(second / 60)) + Number(t1?.[1]) + mins;
        var hours = Math?.floor(parseInt(minutes / 60));
        hrs = Number(t1?.[0]) + hrs + hours;
        mins = minutes % 60;
        sec = second % 60;
        hrs = hrs;
        mins = mins;
        sec = sec;
      }
    });
    setTotalVideoDuration([hrs, mins, sec]);
  }, [shotclassDataByProgram]);
  const { handleCheckOne } = useCheckList("ID", data, setData, setUpdatedData);
  const handleUserStatus = (e, rowData) => {
    let isPublished = e.target.value === "true" ? false : true;
    let data = {
      ID: rowData.ID,
      IsPublished: isPublished,
      Name: rowData.Name,
    };
    dispatch(updateProgramActionHandler(data, navigate, tenantName)).then(
      (response) => {
        if (response) {
          handleCheckOne(data.ID);
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Program ${data.Name} got ${
                data.IsPublished === true ? "Published" : "UnPublished"
              } Successfully`
            )
          );
          handleSearchQuery("");
        }
      }
    );
  };
  useEffect(() => {
    let newTableColumns = columns(
      handleDelete,
      handleEdit,
      handlePreview,
      handleUserStatus,
      navigate,
      tenantName
    );
    setSeriesColumns(newTableColumns);
  }, [columns]);
  useEffect(() => {
    dispatch(
      getAllProgramsCountOrganizeWithoutConditionActionHandler(
        "Published",
        "Program",
        searchQuery && searchQuery,
        setProgramCount
      )
    );
  }, [dispatch, handleDelete, searchQuery, deleteData]);

  useEffect(() => {
    if (deleteData) {
      handleSearchQuery("");
      setdeleteModal(false);
    }
    setdeleteData(null);
  }, [deleteData, setdeleteModal, setProgramCount]);
  return (
    <>
      <DataTable
        columns={seriesColumns}
        defaultData={data}
        setDefaultData={setData}
        data={updatedData}
        setData={setUpdatedData}
        totalRows={programCount}
        // loading={data?.length === 0 ? true : false}
        loading={loading}
        uniqueFieldName={"ID"}
        fetchMoreData={handleCurrentPage}
        searchable
        searchQuery={searchQuery}
        setSearchQuery={handleSearchQuery}
        placeholder={searchPlaceholder}
      />
      {previewSelectedDataModalOpen && (
        <ShotClassPreviewData
          previewSelectedDataModalOpen={previewSelectedDataModalOpen}
          setPreviewSelectedDataModalOpen={setPreviewSelectedDataModalOpen}
          shotclassDataByProgram={shotclassDataByProgram}
          previewCreator={previewCreator}
          previewCreatedOn={previewCreatedOn}
          totalVideoDuration={totalVideoDuration}
          loader={loader}
        />
      )}
      {
        <SeriesDeleteModal
          deleteModal={deleteModal}
          setDeleteModal={setdeleteModal}
          programData={programData}
          setDeleteSeriesData={setdeleteData}
        />
      }
    </>
  );
};

export default SeriesMgmtTable;
